module.exports = __webpack_public_path__ + "img/receipt.ab2ad373.svg";